import { render } from "./TrainingSectionIconBlocksAccordion.vue?vue&type=template&id=37b44035&scoped=true"
import script from "./TrainingSectionIconBlocksAccordion.vue?vue&type=script&lang=js"
export * from "./TrainingSectionIconBlocksAccordion.vue?vue&type=script&lang=js"

import "./TrainingSectionIconBlocksAccordion.vue?vue&type=style&index=0&id=37b44035&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b44035"]])

export default __exports__